//------------------------------------------------------------------------
// Jump Navigation
//------------------------------------------------------------------------
"use strict";
import ExpandToggle from "@threespot/expand-toggle";

export default class SubNav {
  constructor(el) {
    this.el = el;

    // Create a dummy “sentinel” element to determine when the nav is sticky,
    // since “top: 0” means it will never leave the viewport.
    // See https://developers.google.com/web/updates/2017/09/sticky-headers
    this.sentiel = document.createElement('div');
    this.el.parentNode.insertBefore(this.sentiel, this.el);

    // Mobile nav toggle setup
    //---------------------------------
    // NOTE: Breakpoint must match $bp-small in _page-header.scss
    this.mediaQueryList = window.matchMedia("(min-width: 768px)");
    this.toggle = this.el.querySelector(".Subnav-about-toggle");

    // Listen for breakpoint change
    this.mediaQueryList.addEventListener('change', (evt) => {
      if (evt.matches) {
        this.destroyToggle();
      } else {
        this.initToggle();
      }
    });

    // Init on load
    if (!this.mediaQueryList.matches) {
      this.initToggle();
    }

    // Toggle a class when menu is sticky
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.el.classList.toggle("is-sticky", !entry.isIntersecting);
          });
        }, { threshold: [1] }
      );

      this.observer.observe(this.sentiel);
    }
  }

  initToggle() {
    this.toggleExpand = new ExpandToggle(this.toggle);
  }

  destroyToggle() {
    this.toggleExpand.destroy();
  }
}

function activeItem(){
    let navItems = document.querySelectorAll('.JumpNav-item');
    const hash = window.location.hash;
    const jumpLink = document.querySelectorAll('.JumpNav-item a');

    jumpLink.forEach(href => {
      if (href.hash === hash) {
        href.parentNode.classList.add('is-active-jump-link');
      }
    })

    navItems.forEach(link => {
        link.addEventListener('click', function(){
            navItems.forEach(checked => {
              if (checked.classList.contains('is-active-jump-link')) {
                checked.classList.remove('is-active-jump-link');
              }
            });

            link.classList.add('is-active-jump-link');
        });
    });
}

const init = () => {
  let subnav = document.querySelector(".JumpNav");

  if (subnav) {
    new SubNav(subnav);
    activeItem();
  }
};

// Init on initial page load
init();

